/* eslint-disable react/prop-types */
import classes from './SubServ.module.scss';
import {Link} from 'react-router-dom';
import {linkToProduct} from '../Data/ProductsDetails' ;



const Card = ({title , to , img})=>{
    return (
        <Link to={to}>
        <div className={classes["room__card"]}>
            <div className={classes["room__card__image"]}>
                <img src={img} alt="product" loading="lazy"/>
            </div>
            <div className={classes["room__card__details"]}>
                <h4>{title}</h4>
            </div>
        </div>
        </Link>
    )
}

function SubServ({products , title , overview}) {
    return (
        <section className={`${classes["room__container"]} ${classes["section__container"]}`}>
            <p className={classes["section__subheader"]}>{title}</p>
            <h2 className={classes["section__header"]}>{overview}</h2>
            <div className={classes["room__grid"]}>
                {products.map((ele,i)=>{
                    let link = linkToProduct(ele.title_2?ele.title_2:ele.title);
                    ele.to = link
                    return((<Card  key={i} title={ele.title} img={ele.img} to={ele.to}/>))
                })}
            </div>
        </section>
    )
}

export default SubServ